// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"63480e05","796":"737c3d68"}[chunkId] + ".chunk.js";
};